<template>
<div id="app">
    <Slider :slideConfig="slideConfig"/>
</div>
</template>

<script>
import Slider from './components/Slider'

import slideConfig from './slideConfig'

export default {
    name: 'App',
    data() {
        return {
            slideConfig
        }
    },
    components: {
        Slider
    }
}
</script>

<style>
html, body{
	height: 100%;
	width: 100%;
	overflow: hidden;
}
	#app {
	  font-family: "Avenir", Helvetica, Arial, sans-serif;
	  -webkit-font-smoothing: antialiased;
	  -moz-osx-font-smoothing: grayscale;
	  text-align: center;
	  color: #2c3e50;
	  margin-top: 200px;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue